/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: { root: Item<'Page'> } = {
  root: {
    children: [],
    itemId: 'root',
    parent: 'root',
    props: {
      backgroundColor: 'default',
      padding: { all: 40 },
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
